import { cn } from '@/lib/utils';
import type { PropsWithChildren } from 'react';

type Props = {
    className?: string;
} & PropsWithChildren;

export const DataText: React.FC<Props> = ({ children, className = '' }) => {
    return <span className={cn('tabular-nums', className)}>{children}</span>;
};
